export interface Project {
  id: number
  title: string
  description: string
  image: string
  category: string
  year: string
  /** Detailed paragraph describing the work completed for the project details page */
  detailedDescription: string
  /** URL for the "before" photo showing the space prior to work */
  beforeImage: string
  /** URL for the "after" photo showing the completed work */
  afterImage: string
  /** Additional after photos */
  additionalImages?: string[]
}

export const projects: Project[] = [
  {
    id: 1584,
    title: 'Chemical Processing Facility',
    description: 'Designed, supplied, and installed two custom 8-foot explosion-proof walk-in fume hoods, and one 4-foot bench mounted fume hood.',
    image: '/assets/projects/chemical-processing-facility-1/IMG_0664.PNG',
    category: 'Industrial',
    year: '2020',
    detailedDescription: 'Three-day installation.  Designed, supplied, and installed two custom 8-foot explosion-proof walk-in fume hoods, and one 4-foot bench mounted fume hood.  Also installed base cabinets, sinks, mixing valves, flammable material storage cabinets, and chemical storage cabinets.',
    beforeImage: '',
    afterImage: '/assets/projects/chemical-processing-facility-1/IMG_0664.PNG',
  },
  {
    id: 1881, 
    title: 'Chemical Process Engineering Research Facility',
    description: 'Demolished and replaced failed countertops for an active lab.',
    image: '/assets/projects/countertop-repair-1/IMG_0701.PNG',
    category: 'Research',
    year: '2021',
    detailedDescription: 'Our team delivered a 24-hour demolition and repair of failed countertops for an active lab.  We installed new one-inch thick Durcon epoxy resin countertops with drop-in sinks, field-applied backsplashes.  We replaced the fume hood deck without removing the operating hood.',
    beforeImage: '',
    afterImage: '/assets/projects/countertop-repair-1/IMG_0701.PNG',
  },
  {
    id: 1649,
    title: 'SAM Approved Research Facility',
    description: 'Removed and replaced fume hood decks without removing fume hoods.',
    image: '/assets/projects/fume-hood-repair-1/IMG_0661.PNG',
    category: 'Research',
    year: '2018',
    detailedDescription: 'Removed and replaced fume hood decks without removing fume hoods.  24-hour turnaround on a Saturday to minimize disruption of daily operations.',
    beforeImage: '/assets/projects/fume-hood-repair-1/IMG_0663.PNG',
    afterImage: '/assets/projects/fume-hood-repair-1/IMG_0661.PNG',
  },
  {
    id: 1641,
    title: 'High School Lab',
    description: 'New construction, supplied and installed three demonstration fume hoods',
    image: '/assets/projects/high-school-lab-1/IMG_0685.PNG',
    category: 'Education',
    year: '2020',
    detailedDescription: 'Within two days, we supplied and installed three demonstration fume hoods on p-lam casework with epoxy resin fume hood decks for a newly constructed high school lab.',
    beforeImage: '',
    afterImage: '/assets/projects/high-school-lab-1/IMG_0685.PNG',
  },
  {
    id: 1796,
    title: 'Medical Research Hospital',
    description: 'Lab remodel, supplied and installed seven five-foot fume hoods with steel base cabinets.',
    image: '/assets/projects/medical-1/IMG_0670.PNG',
    category: 'Medical',
    year: '2022',
    detailedDescription: '6-day project. We supplied and installed seven five-foot fume hoods with steel base cabinets and cup sinks for a medical research hospital lab remodel.',
    beforeImage: '',
    afterImage: '/assets/projects/medical-1/IMG_0670.PNG',
  },
  {
    id: 1730,
    title: 'Research and Development Lab',
    description: 'Lab remodel, designed, supplied, and installed four eight-foot fume hoods with Chemsurf p-lam base cabinets.',
    image: '/assets/projects/research-facility-remodel-1/IMG_0175.jpg',
    category: 'Research',
    year: '2021',
    detailedDescription: '8-day project. We designed, supplied, and installed four eight-foot fume hoods with Chemsurf p-lam base cabinets for a research and development lab remodel.',
    beforeImage: '',
    afterImage: '/assets/projects/research-facility-remodel-1/IMG_0175.jpg',
  },
  {
    id: 10000,
    title: 'Wastewater Treatment Plant',
    description: 'Restored a fire-damaged lab station at a wastewater treatment facility to full operation.',
    image: '/assets/projects/wastewater-treatment-plant/after1.jpeg',
    category: 'Industrial',
    year: '2026',
    detailedDescription: 'Restored a fire-damaged lab station at a wastewater treatment plant to full operation, replacing casework, plumbing, and fume hood.',
    beforeImage: '/assets/projects/wastewater-treatment-plant/before1.jpeg',
    afterImage: '/assets/projects/wastewater-treatment-plant/after1.jpeg',
    additionalImages: ['/assets/projects/wastewater-treatment-plant/after2.jpeg'],
  },
  {
    id: 7,
    title: 'Lab Efficiency Audit',
    description: 'Comprehensive efficiency assessment and optimization recommendations for an existing laboratory facility. Our efficiency audits have saved over a million dollars in operating expenses on a single project.',
    image: '/assets/istockphoto-1389079639-612x612.jpg',
    category: 'Efficiency Audit',
    year: '2023',
    detailedDescription: 'We conducted a comprehensive efficiency audit for a major research institution\'s laboratory complex. Our team analyzed fume hood usage patterns, ventilation system performance, and equipment utilization across multiple buildings. We identified opportunities to reduce energy consumption by 40% through fume hood sash management, equipment scheduling, and ventilation optimization. We also recommended upgrades to aging casework and plumbing that were causing maintenance issues. The client implemented our recommendations and has reported significant savings in operating expenses. Our efficiency audits have saved clients over a million dollars in operating expenses on a single project.',
    beforeImage: '',
    afterImage: '',
  },
  
]
/*
{
    id: 8,
    title: 'Aerospace Installation',
    description: 'Specialized laboratory setup for aerospace research and testing, including custom fume hoods and precision equipment installation.',
    image: '',
    category: 'Aerospace',
    year: '2023',
    detailedDescription: 'This aerospace research facility required specialized laboratory installations to support materials testing and composite research. We installed custom fume hoods with enhanced airflow for resin and chemical work, precision-leveled work surfaces for sensitive equipment, and specialized ventilation for thermal testing areas. The project included metal casework with chemical-resistant coatings and custom storage solutions for aerospace-grade materials. Our team\'s expertise in lab equipment and parts sourcing was critical for meeting the client\'s stringent specifications. The facility is now supporting critical aerospace R&D programs.',
    beforeImage: '',
    afterImage: '',
  },
*/

export function getProjectById(id: number): Project | undefined {
  return projects.find((p) => p.id === id)
}
